<template>
  <admin-wrapper
    title-translation-path="admin.MASTERPLAN_ILLUMINATION"
    :moduleEnabler="moduleEnabler"
    :hasButtons="false"
  >
    <template #postForm>
      <admin-tabs-layers
        scope="masterplan_illumination"
        class="pt-8"
        schema_scope="masterplan_illumination"
        :tab-prop="tab"
      />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'MasterplanIlluminationSettings',
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'masterplan_illumination_module_enabled',
        translationPath: 'admin.MASTERPLAN_ILLUMINATION',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', {
          suffix: this.$i18n.t('admin.MASTERPLAN_ILLUMINATION'),
        }),
      };
    },
  },
};
</script>
